import CityPage from "../CityPage";

export default function WesternSprings() {
  return <CityPage slug="western-springs" />;
}
